import React from "react";
import PropTypes from "prop-types";
import { Modal } from "components/common/modal";
import { Button } from "components/common/button";
import styles from "components/documents/change-doctype-modal.scss";

export const ChangeDocumentTypeModal = ({
  accountId,
  documentType,
  isChangeDocTypeVisible,
  onChangeDocType,
  onHideChangeDocType
}) => (
  <Modal
    isVisible={ isChangeDocTypeVisible }
    onClose={ onHideChangeDocType }
    transitionName={ "change-doc-type" }
  >
    <div>
      <h3>Change document type to { documentType === "receipt" ? "other document" : "receipt" }?</h3>
      <div className={ styles.buttons }>
        <Button link onClick={ onHideChangeDocType }>cancel</Button>
        <Button onClick={ () => { onChangeDocType(accountId); onHideChangeDocType(); } } primary>Confirm</Button>
      </div>
    </div>
  </Modal>
);

ChangeDocumentTypeModal.defaultProps = {
  documentType: undefined
};

ChangeDocumentTypeModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  documentType: PropTypes.string,
  isChangeDocTypeVisible: PropTypes.bool.isRequired,
  onChangeDocType: PropTypes.func.isRequired,
  onHideChangeDocType: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/documents/modals/change-doctype-modal.jsx